import React, { FC, useEffect, useState, useCallback } from 'react'
import s from './Accordion.module.css'
import BlockContent from '@sanity/block-content-to-react'
import { Plus, Minus } from '@components/icons'
import { showHtml } from '@lib/utils/utils'
import { AnimatePresence, motion } from "framer-motion"
// React 18: framer-motion 4 AnimatePresenceProps doesn't include children
const AnimatePresenceCompat = AnimatePresence as React.ComponentType<{ children?: React.ReactNode; initial?: boolean }>
export interface AccordionProps {
  children?: React.ReactNode
  title?: string
  content?: any
  toggleClassName?: string
  small?: boolean
  showIndex: number
  showIndices?: boolean
  index?: any
  manageIndex?: any
}

const Accordion: React.FC<AccordionProps> = ((props) => {

  const toggle = () => {
    manageIndex((index))
  };
  const {
    title,
    content,
    toggleClassName,
    small,
    showIndex,
    index,
    manageIndex,
    showIndices
  } = props

  return (
    <AnimatePresenceCompat>
      <div
        className={s.root + ' ' + (small ? 'small' : '')}
      >
        <button onClick={toggle} type="button" className={`${s.button} ${small ? 'py-4' : 'py-8'} ${toggleClassName}`}>
          <p className={`${s.button_text} text-left relative `}><span className={small && showIndices !== false ? '' : 'hidden'}>{index}. </span>{title}</p>
          <span className={s.icon}>{index == showIndex ? (small ? <span className={'icon-22-CaretUp-22 text-icon22 '}/> : <span className={'icon-22-Minus-22 md:icon-32-Minus-32 text-icon22 md:text-icon32 '}></span>) : (small ? <span className={'icon-22-CaretDown-22 text-icon22 '}></span> : <span className={'icon-22-Plus-22 md:icon-32-Plus-32 text-icon22 md:text-icon32 '}></span>)}</span>
        </button>
        <AnimatePresenceCompat initial={false}>
          { (index == showIndex ) && <motion.div
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: "auto" },
              collapsed: { height: 0 }
            }}
            className={s.content}
          >
            { content &&
              <div className={`pb-10 textbox ` + (small ? s.smallContent : '')}>
                { typeof(content) === 'string' && <span dangerouslySetInnerHTML={showHtml(content)}></span> }
                { typeof(content) !== 'string' && <BlockContent blocks={content}/> }
              </div>
            }
            { props.children && <div>{ props.children }</div> }
          </motion.div>}
        </AnimatePresenceCompat>
      </div>
    </AnimatePresenceCompat>
  )
})

export default Accordion
